import { render, staticRenderFns } from "./PrivilegeRole.vue?vue&type=template&id=217389f4"
import script from "./PrivilegeRole.vue?vue&type=script&lang=js"
export * from "./PrivilegeRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports